import { render, staticRenderFns } from "./dialog-lms-update.vue?vue&type=template&id=77d69f2d&"
import script from "./dialog-lms-update.vue?vue&type=script&lang=js&"
export * from "./dialog-lms-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports